export default "__VITE_ASSET__DIPd056N__"